<template>
    <div>
      <Header v-if="!hideHeaderFooterArr.includes($route.path)"/>
      <router-view></router-view>
      <Footer v-if="!hideHeaderFooterArr.includes($route.path)"/>
    </div>
</template>
<script>
import Header from '@/components/header/index.vue';
import Footer from '@/components/footer/index.vue';
import { getConfig } from '@/common/api';
export default {
  name: 'MainComponent',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      hideHeaderFooterArr: ['/privacy', '/terms']
    }
  },
  created () {
    getConfig().then(res => {
      localStorage.setItem('config', JSON.stringify(res.data))
    })
  },

}
</script>